import { render, staticRenderFns } from "./BsSubheader.vue?vue&type=template&id=0a2e3e10&"
import script from "./BsSubheader.vue?vue&type=script&lang=js&"
export * from "./BsSubheader.vue?vue&type=script&lang=js&"
import style0 from "./BsSubheader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports